'use strict';

var $ = require('../internals/export');

var IS_PURE = require('../internals/is-pure');

var getBuiltIn = require('../internals/get-built-in');

var anObject = require('../internals/an-object');

var aFunction = require('../internals/a-function');

var speciesConstructor = require('../internals/species-constructor');

var iterate = require('../internals/iterate'); // `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods


$({
  target: 'Set',
  proto: true,
  real: true,
  forced: IS_PURE
}, {
  difference: function difference(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))(set);
    var remover = aFunction(newSet['delete']);
    iterate(iterable, function (value) {
      remover.call(newSet, value);
    });
    return newSet;
  }
});